"use client";

// global-error replaces the entire root layout when the root layout itself
// throws, so it can't rely on globals.css / next/font being loaded - brand
// colors and layout are inlined here on purpose (see Next's error.js docs).
export default function GlobalError({
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return (
    <html lang="pl">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1.5rem",
          padding: "2rem",
          textAlign: "center",
          backgroundColor: "#fdf0f4",
          color: "#18181b",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#e0507a",
          }}
        >
          Coś poszło nie tak
        </p>
        <h1 style={{ margin: 0, fontSize: "1.75rem", fontWeight: 700 }}>
          Malindra Travel napotkała problem
        </h1>
        <p style={{ margin: 0, maxWidth: 420, fontSize: "0.925rem", lineHeight: 1.6, color: "#3f3f46" }}>
          Spróbuj odświeżyć stronę. Jeśli problem się powtarza, wróć na stronę główną.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", justifyContent: "center" }}>
          <button
            type="button"
            onClick={() => unstable_retry()}
            style={{
              borderRadius: 9999,
              border: "none",
              backgroundColor: "#e8607a",
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.875rem",
              padding: "0.875rem 2rem",
              cursor: "pointer",
            }}
          >
            Spróbuj ponownie
          </button>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error replaces the root layout, so a plain hard navigation is the safest option here rather than depending on router state that may itself be broken */}
          <a
            href="/"
            style={{
              borderRadius: 9999,
              border: "1px solid #e0507a",
              color: "#e0507a",
              fontWeight: 700,
              fontSize: "0.875rem",
              padding: "0.875rem 2rem",
              textDecoration: "none",
            }}
          >
            Strona główna
          </a>
        </div>
      </body>
    </html>
  );
}
